module.exports = __webpack_public_path__ + "static/media/question_icon.654bad61.svg";